var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYearDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow04",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.612,
    height: 9.469,
    viewBox: "0 0 16.612 9.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M8.307,106.61a1.16,1.16,0,0,1-.822-.341L.342,99.126a1.163,1.163,0,0,1,1.645-1.645l6.32,6.32,6.32-6.32a1.163,1.163,0,1,1,1.645,1.645l-7.143,7.143A1.16,1.16,0,0,1,8.307,106.61Z",
    transform: "translate(-0.001 -97.14)",
    fill: "#171717"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYearDropDown);
export default __webpack_public_path__ + "static/media/year-drop-down.4dcc5679757118ff2b3004221a7f2c19.svg";
export { ForwardRef as ReactComponent };